import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Button from '../components/common/Button';

/**
 * NotFound page for 404 errors
 * @returns {JSX.Element} NotFound page component
 */
const NotFound = () => {
  return (
    <div className="bg-gray-100 min-h-screen">      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-8 max-w-md mx-auto text-center">
          <h1 className="text-9xl font-bold text-blue-600">404</h1>
          <h2 className="text-2xl font-bold text-gray-900 mt-4">Page Not Found</h2>
          <p className="text-gray-500 mt-2">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="mt-8 space-y-4">
            <Link to="/">
              <Button variant="primary" isFullWidth>
                Go to Home Page
              </Button>
            </Link>
            <Link to="/communities">
              <Button variant="light" isFullWidth>
                Explore Communities
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;